import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { WorkerFileService } from '../data/worker-file.service';
import { WorkerFileVerificationDetailsDto } from '../models/dtos/worker-file-verification-details-dto';
import { WorkerFileVerificationStatusEnum } from '../common/enums/worker-file-verification-status';
import { SnackBarService } from '../shared/services/snack-bar.service';
import { Messages } from '../common/enums/messages';

@Component({
  selector: 'app-worker-file-verification',
  templateUrl: './worker-file-verification.component.html',
  styleUrls: ['./worker-file-verification.component.scss'],
  standalone: false
})
export class WorkerFileVerificationComponent implements OnInit {
  details: WorkerFileVerificationDetailsDto | null = null;
  isLoading = true;
  actionLoading = false;

  approveForm: FormGroup;
  rejectForm: FormGroup;

  readonly statusEnum = WorkerFileVerificationStatusEnum;

  private route = inject(ActivatedRoute);
  private workerFileService = inject(WorkerFileService);
  private spinner = inject(NgxSpinnerService);
  private snackbar = inject(SnackBarService);
  private fb = inject(FormBuilder);

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));

    this.approveForm = this.fb.group({
      institutionId: [null, Validators.required]
    });

    this.rejectForm = this.fb.group({
      reason: ['', Validators.required]
    });

    this.spinner.show();
    this.workerFileService.getWorkerFileVerificationDetails(id).subscribe({
      next: (data) => {
        this.details = data;
        this.isLoading = false;
        this.spinner.hide();
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.spinner.hide();
      }
    });
  }

  approve(): void {
    if (this.approveForm.invalid || !this.details) {
      return;
    }
    this.actionLoading = true;
    const institutionId = this.approveForm.value.institutionId;

    if (!this.details) {
      return;
    } 

    this.workerFileService.approveWorkerFile(this.details.FileId, institutionId).subscribe({
      next: () => {
        this.snackbar.openSuccessSnackBar(Messages.WorkerFileVerificationApproveSuccess);
        this.details = { ...this.details! as WorkerFileVerificationDetailsDto, VerificationStatusId: this.statusEnum.Approved };
        this.actionLoading = false;
      },
      error: () => {
        this.actionLoading = false;
      }
    });
  }

  reject(): void {
    if (this.approveForm.invalid || !this.details) {
      return;
    }
    this.actionLoading = true;
    const reason = this.rejectForm.value.reason;

    this.workerFileService.rejectWorkerFile(this.details.FileId, reason).subscribe({
      next: () => {
        this.snackbar.openSuccessSnackBar(Messages.WorkerFileVerificationRejectSuccess);
        this.details = { ...this.details! as WorkerFileVerificationDetailsDto, VerificationStatusId: this.statusEnum.Rejected, RejectionReason: reason };
        this.actionLoading = false;
      },
      error: () => {
        this.actionLoading = false;
      }
    });
  }
}
